import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const Contact = () => {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative bg-[#0B0807]/82 backdrop-blur-md py-24 sm:py-32 lg:py-40 px-4 sm:px-8 lg:px-12 border-t border-white/5 overflow-hidden"
        >
            <div className="flex items-center gap-3 font-mono-text text-[10px] sm:text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">
                <span className="h-px w-10 bg-[#D69331]" />
                <span>11 / Contact</span>
            </div>

            <motion.h2
                initial={{ y: 60, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="font-display uppercase font-bold leading-[0.82] tracking-tight text-white text-5xl sm:text-7xl lg:text-9xl"
            >
                Let's build{" "}
                <span className="text-[#D69331]">global trade</span>{" "}
                together.
            </motion.h2>

            <p className="mt-10 font-mono-text text-sm sm:text-base text-zinc-300 leading-relaxed max-w-3xl">
                We welcome partnerships, collaborations and business inquiries
                from manufacturers, suppliers, distributors, retailers and
                international trade partners. Whether you are looking to source
                products, expand into new markets or develop long-term supply
                chain partnerships, our team is ready to support your business
                growth.
            </p>

            <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-px bg-zinc-900 border border-zinc-900">
                <div className="lg:col-span-7 bg-[#0a0a0a] p-8 sm:p-10 lg:p-12 flex flex-col justify-between min-h-[260px]">
                    <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                        Direct Channel
                    </span>
                    <a
                        href="mailto:info@duhagt.com"
                        data-testid="contact-email-cta"
                        className="mt-6 inline-flex items-baseline gap-3 font-display uppercase text-3xl sm:text-5xl lg:text-6xl font-bold text-white hover:text-[#D69331] transition-colors break-all"
                    >
                        info@duhagt.com
                        <ArrowUpRight
                            size={28}
                            className="shrink-0 -translate-y-1"
                        />
                    </a>
                </div>

                <div className="lg:col-span-5 bg-[#0a0a0a] p-8 sm:p-10 lg:p-12 flex flex-col gap-6">
                    <div>
                        <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                            Company
                        </span>
                        <p className="mt-2 font-display uppercase text-lg sm:text-xl text-white">
                            DUHA Global Trading Sdn. Bhd.
                        </p>
                    </div>
                    <div>
                        <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                            Business Activities
                        </span>
                        <p className="mt-2 font-mono-text text-sm text-zinc-300 leading-relaxed">
                            International Trade · FMCG Distribution · Halal
                            Supply Chain · Import & Export · Private Label
                            Development
                        </p>
                    </div>
                    <a
                        href="mailto:info@duhagt.com"
                        data-testid="contact-cta-button"
                        className="mt-auto inline-flex items-center justify-center gap-3 px-6 py-4 bg-[#D69331] text-black font-mono-text text-xs font-bold uppercase tracking-[0.25em] hover:bg-white transition-colors"
                    >
                        Start Your Global Trade Journey →
                    </a>
                </div>
            </div>
        </section>
    );
};
